module.exports = __webpack_public_path__ + "static/img/h6.0e3aca7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h6.jpg
// module id = YwEu
// module chunks = 0